export default __webpack_public_path__ + "static/media/HSU_Logo2.d18d9a4f.svg";